export function validateStringWordCount(string, min) {
  if (!string || typeof string !== "string") {
    return false;
  } else {
    return string.split(" ").length > min;
  }
}
